import {Injectable} from '@angular/core';
import {ValidatorFn, Validators} from '@angular/forms';
import {FieldBlock} from '../models/form-schema.model';

@Injectable({
  providedIn: 'root'
})
export class ValidatorMapperService {
  mapValidators(field: FieldBlock): ValidatorFn[] {
    const validators: ValidatorFn[] = [];

    if (field.required) {
      validators.push(Validators.required);
    }

    // `email` field type implies an e-mail format validator.
    if (field.type === 'email') {
      validators.push(Validators.email);
    }

    if (field.validators) {
      const {min, max, minLength, maxLength, pattern, email, minDate, maxDate} = field.validators;

      if (min !== undefined && min !== null) {
        validators.push(Validators.min(Number(min)));
      }

      if (max !== undefined && max !== null) {
        validators.push(Validators.max(Number(max)));
      }

      if (minLength !== undefined && minLength !== null) {
        validators.push(Validators.minLength(Number(minLength)));
      }

      if (maxLength !== undefined && maxLength !== null) {
        validators.push(Validators.maxLength(Number(maxLength)));
      }

      if (pattern) {
        validators.push(Validators.pattern(pattern));
      }

      if (email && field.type !== 'email') {
        validators.push(Validators.email);
      }

      if (minDate) {
        validators.push((control) => {
          if (!control.value) return null;
          return new Date(control.value) < new Date(minDate) ? {minDate: {minDate}} : null;
        });
      }

      if (maxDate) {
        validators.push((control) => {
          if (!control.value) return null;
          return new Date(control.value) > new Date(maxDate) ? {maxDate: {maxDate}} : null;
        });
      }
    }

    return validators;
  }
}
